import { render, staticRenderFns } from "./DashboardGridCampaignCodeColumn.vue?vue&type=template&id=b85ce84c&"
import script from "./DashboardGridCampaignCodeColumn.vue?vue&type=script&lang=ts&"
export * from "./DashboardGridCampaignCodeColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports